import { Collection, HomeDelivery, } from 'helpers/productPrice/fulfilmentOptions';
import { ActivePaperProductTypes } from 'helpers/productPrice/productOptions';
function getSavingsForFulfilmentOption(prices, fulfilmentOption) {
    return ActivePaperProductTypes.map((productOption) => {
        const price = prices[fulfilmentOption]?.[productOption]?.Monthly?.GBP;
        return price?.savingVsRetail ?? 0;
    });
}
function getMaxSavingVsRetail(productPrices) {
    const countryPrices = productPrices['United Kingdom'];
    if (countryPrices) {
        const allSavings = getSavingsForFulfilmentOption(countryPrices, Collection).concat(getSavingsForFulfilmentOption(countryPrices, HomeDelivery));
        return Math.max(...allSavings);
    }
    return;
}
export { getMaxSavingVsRetail };
